module.exports = __webpack_public_path__ + "static/media/ash Ellipse.278d2158.svg";